import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { pagosAPI } from '../services/api';

const PayphoneCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [estado, setEstado] = useState('procesando'); // procesando, aprobado, rechazado, error
  const [resultado, setResultado] = useState(null);

  useEffect(() => {
    confirmarPago();
    // eslint-disable-next-line
  }, []);

  const confirmarPago = async () => {
    try {
      const id = searchParams.get('id');
      const clientTransactionId = searchParams.get('clientTransactionId');

      if (!id || !clientTransactionId) {
        setEstado('error');
        return;
      }

      const res = await pagosAPI.payphoneConfirm({ id, clientTransactionId });

      if (res.data.success) {
        setResultado(res.data.data);
        if (res.data.approved) {
          setEstado('aprobado');
          toast.success('Pago aprobado exitosamente');
        } else {
          setEstado('rechazado');
          toast.error('Pago rechazado o cancelado');
        }
      } else {
        setEstado('error');
      }
    } catch (error) {
      console.error('Error confirmando pago:', error);
      setEstado('error');
      toast.error('Error al confirmar el pago');
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body text-center py-5">
              {estado === 'procesando' && (
                <>
                  <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }}></div>
                  <h4>Confirmando pago...</h4>
                  <p className="text-muted">Por favor espere mientras verificamos su transaccion con Payphone</p>
                </>
              )}

              {estado === 'aprobado' && (
                <>
                  <div className="mb-3">
                    <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
                  </div>
                  <h3 className="text-success">Pago Aprobado</h3>
                  <p className="text-muted mb-3">Su pago ha sido procesado exitosamente</p>
                  {resultado && (
                    <div className="text-start bg-light rounded p-3 mb-3">
                      <div className="row g-2">
                        <div className="col-6"><small className="text-muted">Transaccion</small><br /><strong>{resultado.transactionId}</strong></div>
                        <div className="col-6"><small className="text-muted">Autorizacion</small><br /><strong>{resultado.authorizationCode}</strong></div>
                        <div className="col-6"><small className="text-muted">Tarjeta</small><br /><strong>{resultado.cardBrand} ****{resultado.lastDigits}</strong></div>
                        <div className="col-6"><small className="text-muted">Monto</small><br /><strong>${((resultado.amount || 0) / 100).toFixed(2)}</strong></div>
                      </div>
                    </div>
                  )}
                  <button className="btn btn-primary btn-lg" onClick={() => navigate('/ventas')}>
                    <i className="bi bi-cart me-2"></i>Volver al POS
                  </button>
                </>
              )}

              {estado === 'rechazado' && (
                <>
                  <div className="mb-3">
                    <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: '4rem' }}></i>
                  </div>
                  <h3 className="text-danger">Pago Rechazado</h3>
                  <p className="text-muted mb-3">
                    {resultado?.transactionStatus === 'Cancelled' ? 'La transaccion fue cancelada' : 'El pago no pudo ser procesado'}
                  </p>
                  <button className="btn btn-primary btn-lg" onClick={() => navigate('/ventas')}>
                    <i className="bi bi-arrow-left me-2"></i>Volver e Intentar Otro Metodo
                  </button>
                </>
              )}

              {estado === 'error' && (
                <>
                  <div className="mb-3">
                    <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '4rem' }}></i>
                  </div>
                  <h3 className="text-warning">Error de Verificacion</h3>
                  <p className="text-muted mb-3">No se pudo verificar el estado del pago. Consulte con el administrador.</p>
                  <button className="btn btn-primary btn-lg" onClick={() => navigate('/ventas')}>
                    <i className="bi bi-arrow-left me-2"></i>Volver al POS
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayphoneCallback;
